import React from "react";
import { Grid, Portal } from "@mui/material";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { WintSuperkollAPIModelExternalCompanyData } from "wint-api-client/dist/types";
//#endregion
//#region components
import {
  FormValidity,
  PageFooter,
  PageLayouts,
  Skeletons,
  useCheckRelations,
  useMountedState,
  ViewPanel,
} from "components/common";
import BoardMemberDetailsFormContainer from "./forms/boardMemberDetailsFormContainer";
import { useCompanyService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const EditBoardMembers: React.FC = (props) => {
  const companyService = useCompanyService();
  const { getMounted } = useMountedState();
  const [boardMembers, setBoardMembers] = React.useState<WintSuperkollAPIModelExternalCompanyData.Director[]>();
  const [loading, setLoading] = React.useState<boolean>(true);

  const companyId = useSelector((store: AppState) => store.auth.selectedCompany.id);
  const formRef = React.useRef<FormHandles>(null);
  const { getIsAdmin, getIsBoard } = useCheckRelations();

  const isAdmin = getIsAdmin();
  const isBoard = getIsBoard();

  React.useEffect(() => {
    loadBoardMembers();
  }, []);

  const loadBoardMembers = () => {
    setLoading(true);
    companyService
      .getCompanyBoardMembers(companyId)
      .then((result) => {
        if (getMounted()) {
          setBoardMembers(result);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const submitForm = () => {
    return (formRef.current && formRef.current.submit()) ?? new Promise<void>((resolve) => resolve());
  };

  const footerMount = () => document.getElementById("reportFooterContainer");

  return (
    <PageLayouts.DashboardLayout<any>
      entityKey={0}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.Board)}
      hasPermissions={isAdmin || isBoard}
      className={cssExports.fullHeight}
    >
      <Grid item container>
        {loading ? (
          <ViewPanel fitContent appearance="sm">
            <Skeletons.TableSkeleton />
          </ViewPanel>
        ) : boardMembers ? (
          <FormValidity
            render={(isDirty, onDirtyChange) => (
              <>
                <BoardMemberDetailsFormContainer
                  ref={formRef}
                  boardMembers={boardMembers}
                  companyId={companyId}
                  onFormDirtyChange={onDirtyChange}
                />
                <Portal container={footerMount()}>
                  <PageFooter
                    actions={
                      isDirty
                        ? [
                            {
                              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
                              onClick: submitForm,
                              type: StyleEnums.DisplayType.Success,
                              successMessage: TranslationKeys.Common.Saved,
                            },
                          ]
                        : []
                    }
                  />
                </Portal>
              </>
            )}
          />
        ) : (
          <></>
        )}
      </Grid>
    </PageLayouts.DashboardLayout>
  );
};

export default EditBoardMembers;
